// extracted by mini-css-extract-plugin
module.exports = {"medium":"_3nh4PIH65Y-button-size-medium-medium","circle":"_2Q6YnZ2Rcv-button-size-medium-circle","pill":"_21cxzfA3li-button-size-medium-pill"};